import { z } from "zod";

export enum ReportParameterTypeEnum {
    TEXT = 1,
    NUMBER = 2,
    DATE = 3,
    LIST = 4,
    CURRENT_PARTNER_ID = 5,
    CURRENT_USER_NAME = 6,
}

export const ReportParameterTypeEnumSchema = z.nativeEnum(ReportParameterTypeEnum);
export type ReportParameterTypeEnumSchema = z.infer<typeof ReportParameterTypeEnumSchema>;

export const getParameterTypeLabel = (type: ReportParameterTypeEnum) => {
    switch (type) {
        case ReportParameterTypeEnum.TEXT:
            return "Text";
        case ReportParameterTypeEnum.NUMBER:
            return "Číslo";
        case ReportParameterTypeEnum.DATE:
            return "Dátum";
        case ReportParameterTypeEnum.LIST:
            return "Zoznam";
        case ReportParameterTypeEnum.CURRENT_PARTNER_ID:
            return "ID partnera";
        case ReportParameterTypeEnum.CURRENT_USER_NAME:
            return "Meno používateľa";
    }
}